// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ICategoryAllowedServiceDto } from './ICategoryAllowedServiceDto';
import {
    ICategoryAllowedServiceDtoFromJSON,
    ICategoryAllowedServiceDtoFromJSONTyped,
    ICategoryAllowedServiceDtoToJSON,
    ICategoryAllowedServiceDtoToJSONTyped,
} from './ICategoryAllowedServiceDto';

/**
 * 
 * @export
 * @interface ICategoryDto
 */
export interface ICategoryDto {
    /**
     * 
     * @type {string}
     * @memberof ICategoryDto
     */
    category_type?: ICategoryDtoCategoryTypeEnum;
    /**
     * 
     * @type {Array<ICategoryAllowedServiceDto>}
     * @memberof ICategoryDto
     */
    services?: Array<ICategoryAllowedServiceDto>;
}

/**
* @export
* @enum {string}
*/
export enum ICategoryDtoCategoryTypeEnum {
    ADOPTION = 'ADOPTION',
    DENTAL = 'DENTAL',
    DEPENDENT_CARE = 'DEPENDENT_CARE',
    MEDICAL = 'MEDICAL',
    PARKING = 'PARKING',
    PREMIUM = 'PREMIUM',
    PHARMACY = 'PHARMACY',
    TRANSIT = 'TRANSIT',
    VISION = 'VISION',
    LIFE_STYLE = 'LIFE_STYLE',
    WELLNESS = 'WELLNESS',
    TRAVEL = 'TRAVEL',
    PLAN_SPECIFIC = 'PLAN_SPECIFIC'
}


/**
 * Check if a given object implements the ICategoryDto interface.
 */
export function instanceOfICategoryDto(value: object): value is ICategoryDto {
    return true;
}

export function ICategoryDtoFromJSON(json: any): ICategoryDto {
    return ICategoryDtoFromJSONTyped(json, false);
}

export function ICategoryDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ICategoryDto {
    if (json == null) {
        return json;
    }
    return {
        
        'category_type': json['category_type'] == null ? undefined : json['category_type'],
        'services': json['services'] == null ? undefined : ((json['services'] as Array<any>).map(ICategoryAllowedServiceDtoFromJSON)),
    };
}

export function ICategoryDtoToJSON(json: any): ICategoryDto {
    return ICategoryDtoToJSONTyped(json, false);
}

export function ICategoryDtoToJSONTyped(value?: ICategoryDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'category_type': value['category_type'],
        'services': value['services'] == null ? undefined : ((value['services'] as Array<any>).map(ICategoryAllowedServiceDtoToJSON)),
    };
}

